import { User } from "./../../services/user";
import { CreditCard } from "./../../services/credit_card";
import { Operator } from "../../services/operator";
import { Verification } from "../../services/verification";

export const state = {
  userRole: "",
  currentUser: {
    name: "",
    phone_number: "",
    nickname: "",
    credit_cards: [],
    insurance_enrollments: [],
    account: {},
    address: {
      street: ""
    }
  }
};

export const getters = {
  getCurrentUser(state) {
    return state.currentUser;
  },
  userRole(state) {
    return state.userRole;
  },
  accountActivated(state) {
    return !!state.currentUser.account.id;
  },
  isEmailConfirmed(state) {
    return !!state.currentUser.confirmed_at;
  },
  isPhoneVerified(state) {
    return !!state.currentUser.phone_verified_at;
  }
};

export const mutations = {
  SET_CURRENT_USER(state, currentUser) {
    state.currentUser = currentUser;
    if (currentUser.doctor_property && currentUser.doctor_property.id) {
      state.currentUser.doctor_property.council_description = `${currentUser.doctor_property.council_name} ${currentUser.doctor_property.council_number} ${currentUser.doctor_property.council_uf}`;
    }
    if (!currentUser.address) currentUser.address = {};
    if (!currentUser.account) currentUser.account = {};
  },
  SET_USER_ROLE(state, currentUser) {
    if (currentUser.profile && currentUser.profile === "operator")
      state.userRole = "operator";
    else
      state.userRole =
        currentUser.doctor_property && currentUser.doctor_property.id
          ? "doctor"
          : "patient";
  },
  ADD_ADDRESS_TO_USER(state, { address }) {
    state.currentUser.address = address;
  },
  ADD_CREDIT_CARDS_TO_USER(state, credit_cards) {
    state.currentUser.credit_cards = credit_cards;
  },
  ADD_NEW_CREDIT_CARD_TO_USER(state, credit_card) {
    state.currentUser.credit_cards.push(credit_card);
  },
  REMOVE_DELETED_CREDIT_CARD(state, credit_card_id) {
    state.currentUser.credit_cards = state.currentUser.credit_cards.map(
      card => card.id != credit_card_id
    );
  },
  UPDATE_CREDIT_CARD(state, { id, nickname }) {
    state.currentUser.credit_cards = state.currentUser.credit_cards.filter(
      credit_card => {
        if (credit_card.id == id) credit_card.nickname = nickname;
      }
    );
  },
  ADD_ACCOUNT(state, account) {
    state.currentUser.account = account;
  },
  UPDATE_DOCTOR_PROPERTY(state, payload) {
    state.currentUser.doctor_property = payload;
  },
  SET_INSURANCE_ENROLLMENTS(state, payload) {
    state.currentUser.insurance_enrollments = payload;
  }
};

export const actions = {
  showUser({ commit, dispatch }, payload) {
    return User.show(payload)
      .then(response => {
        commit("SET_CURRENT_USER", response.data);
        commit("SET_USER_ROLE", response.data);
        dispatch(
          "doctorDocument/syncDocumentRequirements",
          response.data.doctor_property,
          { root: true }
        );
        return response;
      })
      .catch(error => error);
  },

  showOperator({ commit }, payload) {
    return Operator.show(payload).then(response => {
      commit("SET_CURRENT_USER", response.data);
      commit("SET_USER_ROLE", response.data);
      return response;
    });
  },

  async updateUser({ dispatch }, payload) {
    const response = await User.update(payload);
    await dispatch("showUser", payload.id);
    return response;
  },

  addCreditCard({ commit }, payload) {
    return CreditCard.create(payload).then(response => {
      commit("ADD_NEW_CREDIT_CARD_TO_USER", response.data);
      return response;
    });
  },

  async tokenizeCreditCard({}, payload) {
    let card = Object.assign({}, payload);
    const [month, year] = card.expiration.split("/");
    const holder = card.holder_name.split(" ");

    card = {
      number: card.number.replace(/[^0-9.]/g, ""),
      verification_value: card.cvc,
      first_name: holder[0],
      last_name: holder[holder.length - 1],
      month: month,
      year: year
    };

    return new Promise((resolve, reject) => {
      window.Iugu.createPaymentToken(card, function(response) {
        if (response.id) resolve({ token: response.id });

        reject(response);
      });
    });
  },

  updateAnOperator({ dispatch }, payload) {
    return Operator.update(payload)
      .then(response => {
        dispatch("showOperator", payload.id);
      })
      .catch(error => {
        return error;
      });
  },

  fetchUsersAppointments({}, payload) {
    return User.appointments(payload);
  },

  fetchInsuranceEnrollments({ commit }, id) {
    return User.listInsuranceEnrollments(id)
      .then(response => {
        commit("SET_INSURANCE_ENROLLMENTS", response.data);
      })
      .catch(error => error);
  },

  deleteUserCreditCard({ commit }, id) {
    return CreditCard.delete(id)
      .then(response => {
        commit("REMOVE_DELETED_CREDIT_CARD");
      })
      .catch(error => error);
  },

  updateUserCreditCard({ commit }, { id, nickname }) {
    return CreditCard.update({ id, nickname })
      .then(response => {
        commit("UPDATE_CREDIT_CARD", { id, nickname });
      })
      .catch(error => error);
  },

  fetchUserCreditCards({ commit }) {
    return CreditCard.fetch()
      .then(response => {
        commit("ADD_CREDIT_CARDS_TO_USER", response.data);
        return response;
      })
      .catch(error => error);
  },

  emailVerification({}, payload) {
    return User.verifyEmail(payload);
  },

  cpfVerification({}, payload) {
    return User.verifyCpf(payload);
  },

  phoneNumberVerification({}, payload) {
    return User.verifyPhoneNumber(payload);
  },

  showSymptoms({}, payload) {
    return User.showSymptoms(payload);
  },

  deleteUser({}) {
    return User.deleteUser();
  },

  fetchPatients({}) {
    return User.listPatients();
  },

  sendPhoneCode() {
    return Verification.sendPhoneCode();
  },

  verifyPhoneCode({}, code) {
    return Verification.verifyPhoneCode(code);
  },

  resendEmailConfirmation() {
    return Verification.resendEmailConfirmation();
  }
};
